import { type FC, useEffect } from 'react'

import Notification, {
  NOTIFICATION_TYPES,
} from 'views/components/molecules/Notification'
import scrollToTop from 'views/utils/scrollToTop'

const NotificationCart: FC<{
  label?: React.ReactElement
  type?: NOTIFICATION_TYPES
  classNameOverride?: string
  dataQaId?: string
}> = ({
  label,
  children,
  type,
  classNameOverride,
  dataQaId,
}): React.ReactElement => {
  useEffect(() => scrollToTop('smooth'), [label, type, classNameOverride])

  return (
    <div
      className={
        classNameOverride ??
        'l-content a-full-width u-padding-large--left u-padding-large--right m-NotificationCart' // use classNameOverride or default when not given
      }
    >
      <Notification
        label={label ?? children ?? ''}
        type={type ?? NOTIFICATION_TYPES.WARNING}
        className="u-margin--top"
        dataQaId={dataQaId}
      />
    </div>
  )
}

export { NotificationCart }
